import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase'
import type { StatsReportCardProps } from '../../AnalyticsDashboard.types'
import { createStatsData } from '../../utils/createStatsData'

const reportId = 'membership_top_tiers_by_members'

type MembershipsTopTiersByMembersRow = {
  tier: string
  members: number
}

export const useMembershipsTopTiersByMembersReportCard = (): StatsReportCardProps => {
  const analyticsCardBase = useAnalyticsCardBase({ reportId })

  const data = createStatsData<MembershipsTopTiersByMembersRow>({
    rows: analyticsCardBase.reportData?.report?.rows,
    mapFn: (row) => ({
      label: row.tier,
      value: row.members,
    }),
  })

  return {
    ...analyticsCardBase,
    type: 'stats',
    data,
    header: {
      ...analyticsCardBase.header,
      label: 'Top tiers by members',
      tooltip: {
        title: 'Top tiers by members',
        description: 'Most popular membership tiers based on active members.',
      },
    },
  }
}
